import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

// Trivial marker, 2026-09-01: verifying Cloudflare Pages deploys on push
// with no manual `wrangler pages deploy`, now that it is Git connected.
window.__TRADESYNC_PAGES_AUTODEPLOY_CHECK = true

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
